import { Box, IconButton, Stack, Typography } from '@mui/material';
import { DraggableSyntheticListeners } from '@dnd-kit/core';
import { GripVertical, X } from 'lucide-react';
import { useIntl } from 'react-intl';

interface PanelHeaderProps {
    title: string;
    dragListeners: DraggableSyntheticListeners;
    onClose: () => void;
    closeDisabled?: boolean;
}

export default function PanelHeader({
    title,
    dragListeners,
    onClose,
    closeDisabled = false,
}: PanelHeaderProps) {
    const intl = useIntl();

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                pb: 0.75,
                borderBottom: '1px solid',
                borderColor: 'divider',
            }}
        >
            <Stack
                direction="row"
                alignItems="center"
                gap={0.5}
                {...dragListeners}
                sx={{
                    cursor: 'grab',
                    '&:active': { cursor: 'grabbing' },
                    userSelect: 'none',
                    touchAction: 'none',
                }}
            >
                <GripVertical size={12} style={{ opacity: 0.6 }} />
                <Typography fontSize={14} fontWeight={500}>
                    {title}
                </Typography>
            </Stack>
            <IconButton
                size="small"
                onClick={onClose}
                disabled={closeDisabled}
                sx={{ p: 0.25 }}
                title={intl.formatMessage({ id: 'close' })}
                aria-label={intl.formatMessage({ id: 'close' })}
            >
                <X size={16} />
            </IconButton>
        </Box>
    );
}
